import { BIO_MAX } from '@peach/types/tutors/identity-limits.js';
import { zoneName } from '@/lib/utils/when';

/** The calendar's zone, said in the headline over it rather than in a note under the rail. */
const inZone = (timezone: string | null) => (timezone ? ` (times in ${zoneName(timezone)})` : '');

/**
 * The words are `TRIAL_TITLE`'s, which the backend writes to every catalogue
 * trial, so the ask and the card under it cannot drift apart.
 */
export const pickTimeAsk = (name: string, timezone: string | null) =>
  `Pick a time to book an intro call with ${name}${inZone(timezone)}`;

/** Over the first call, laid inside the intro card: the card under it drops its own zone. */
export const nextCallLine = (name: string, when: string, timezone: string) =>
  `Your next call with ${name} is ${when}${inZone(timezone)}`;

/** Over the owner's week, where a visitor reads the calendar: nobody books their own call.
 *  The week is in the owner's own zone, so the line says which. */
export const ownerHoursLine = (timezone: string | null) =>
  `When clients can book you${inZone(timezone)}`;

/** Over the owner's intro card in the grid, which is where its price is set. */
export const OWNER_TRIAL_LINE = 'What an intro call with you costs';

/** The tagline as the masthead says it: whole under `BIO_MAX`, and a bio stored
 *  before the limit fell to 90 is cut at a word with an ellipsis over it. */
export function taglineHeadline(tagline: string | null | undefined): string | null {
  const line = tagline?.trim();
  if (!line) return null;
  if (line.length <= BIO_MAX) return line;
  const cut = line.slice(0, BIO_MAX);
  const atWord = cut.lastIndexOf(' ');
  return `${(atWord > BIO_MAX / 2 ? cut.slice(0, atWord) : cut).replace(/[\s,.;:–-]+$/, '')}…`;
}
